import React, { useContext } from "react";
import { PageStaticDataContext } from "../../contexts/PageStaticDataContextProvider";
import PageConfig from "../../utils/PageConfig";
import { PDPOverview } from "@vp/pdp-overview";

const OverviewWrapper: React.FC = () => {
  const {
    mpv,
    componentData: { overviewData },
  } = useContext(PageStaticDataContext);

  return (
    overviewData && (
      <PDPOverview
        data={{ ...overviewData, showFAQLink: false }}
        tenant={PageConfig.tenant.toLowerCase()}
        id="overview"
        mpvId={mpv.mpvId}
      />
    )
  );
};

export default OverviewWrapper;
